import { t } from "@hakili/i18n";

/** The team door's answer as the screens read it (`GET /api/v1/bank/team`); outside `routes/` so the table and the screen do not import each other. */
export interface TeamMemberView {
  readonly id: string;
  readonly fullName: string;
  readonly email: string;
  readonly role: string;
  readonly statut: "invitationEnAttente" | "actif" | "desactive";
  readonly disponibilite: string | null;
  readonly retourLe: string | null;
  readonly deactivatedOn: string | null;
  readonly invitationPending: boolean;
  /** `SENIORITY-LEVEL`: junior, standard or senior, set by the chef at the invite. */
  readonly level: "junior" | "standard" | "senior";
  readonly openFiles: number;
  readonly points: number;
  /** The open files by stage: every open stage is a key, 0 when none (`GET /api/v1/bank/team`, R-1). */
  readonly stages: Readonly<Record<string, number>>;
}

/** `CHEF-HELD-FILES` (`D-1027-1`): the caller's own portfolio, the files the chef carries himself (`GET /api/v1/bank/team`, `self`). */
export interface TeamSelfView {
  readonly id: string;
  readonly name: string;
  readonly openFiles: number;
  readonly points: number;
  readonly stages: Readonly<Record<string, number>>;
}

export interface TeamRead {
  readonly members: readonly TeamMemberView[];
  readonly weights: Readonly<Record<string, number>>;
  /** The door's own day (`YYYY-MM-DD`): a return day written without its year is read against it, the screen holds no clock. */
  readonly asOf: string;
  /** The caller's own entry, `null` when he carries no file; the analysts' `members` never contain him. */
  readonly self: TeamSelfView | null;
}

/**
 * The name the chef's pipeline filter reads (« Dossiers de {nom} seulement »): an analyst's, or the chef's own as the drawing writes it
 * (`CHEF-HELD-FILES`, « Souleymane Diarra (vous) »); `null` for an id the read does not know.
 */
export function filterNameOf(read: TeamRead | null, userId: string): string | null {
  const member = read?.members.find((one) => one.id === userId);
  if (member !== undefined) return member.fullName;
  return read?.self?.id === userId ? t("bank.equipe.chefVous").replace("{nom}", read.self.name) : null;
}
